// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__walcL","description":"styles_description__g6T4U"};